import Mutations from './mutations.js'
import Actions from './actions.js'
import Getters from './getters.js'

export default {
    namespaced:true,
    state(){
        return {
            chatsound:true,
            chatfontcolor:'#000',
            chatfontsize:11,  
            mode:'',
            mtm_join:[]         
        }
    },
    mutations:Mutations,
    actions:Actions,
    getters:Getters
}
